import {
  Box,
  InputAdornment,
  TextField,
  MenuItem,
  Button
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { DatePicker } from "@mui/x-date-pickers";
import AllVenues from "./AllVenues";
import NewVenue from "./NewVenue";
import { getVenueListforReservation } from "src/redux/slices/venueSlice";
import { getTableSizes } from "src/redux/slices/reservation";
import useGeolocation from "src/utils/geolocation";
import { useSearchParams } from "react-router-dom";
import { openVenueLocationModal } from 'src/redux/slices/VenueLocationModalSlice';

import Iconify from "src/components/iconify/Iconify";
import { Container } from "@mui/system";

const VenueCuisines = () => {
  const dispatch = useDispatch();
  const { tableSizesList } = useSelector((state) => state.tableSizesList);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchParams, setSearchParams] = useSearchParams();
  const [tableSize, setTableSize] = useState(searchParams.get("tableSize") || tableSizesList?.tableSizes?.[1]);
  const [tempTableSize, setTempTableSize] = useState(tableSize);
  const [selectedDate, setSelectedDate] = useState(searchParams.get("selectedDate") || new Date());
  const [timeSlots, setTimeSlots] = useState([]);
  const initialTime = searchParams.get("selectTime") || "";
  const [selectTime, setSelectTime] = useState(initialTime);
  const [open, setOpen] = useState(false);


  useEffect(() => {
    generateTimeSlots(selectedDate);
  }, [selectedDate]);

  useEffect(() => {
    if (timeSlots.length > 0 && !selectTime) {
      setSelectTime(timeSlots[0]);
    }
  }, [timeSlots]);


  const { triggerLocation } = useGeolocation();
  const handleOpenModal = () => dispatch(openVenueLocationModal());

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };
  useEffect(() => {
    dispatch(getTableSizes());
  }, []);

  const handleInputChange = (event, name) => {
    if (name === 'time') {
      setSelectTime(event.target.value)
      setSearchParams({
        tableSize,
        selectedDate,
        selectTime: event.target.value,
      });
    } else if (name === 'partySize') {
      setTableSize(event.target.value);
      setSearchParams({
        tableSize: event.target.value,
        selectedDate,
        selectTime,
      });
    }
  };

  const handleInputChangeDate = (value, name) => {
    setSelectedDate(value);
    setSearchParams({
      tableSize,
      selectedDate: value.toISOString(),
      selectTime,
    })
  };

  const isReservation = localStorage.getItem('isReservation')

  const updateURLParams = () => {
    setTempTableSize(tableSize);
    setSearchParams({
      tableSize,
      selectedDate,
      selectTime,
      tempTableSize: tableSize,
    });
  };


  function formatDateTime(dateStr, timeStr) {
    if (!dateStr || !timeStr) {
      console.warn("Invalid Date or Time", { dateStr, timeStr });
      return "";
    }

    try {
      let dateObj = new Date(`${dateStr}T00:00:00`);

      let [time, period] = timeStr.split(" ");
      period = period.toUpperCase();
      let [hours, minutes] = time.split(":").map(Number);

      if (period === "PM" && hours !== 12) hours += 12;
      if (period === "AM" && hours === 12) hours = 0;

      dateObj.setHours(hours, minutes, 0, 0);

      const utcDate = new Date(dateObj.getTime() - dateObj.getTimezoneOffset() * 60000);

      return utcDate.toISOString().replace(/\.\d{3}Z$/, ".000Z");
    } catch (error) {
      console.error("Error formatting time:", error);
      return "";
    }
  }

  const formatDate = (dateString) => {
    const dateObj = new Date(dateString);
    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    const day = String(dateObj.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };


  const selectedTimeSlot = selectTime || (timeSlots.length > 0 ? timeSlots[0] : "");
  const formattedTime = selectedTimeSlot ? formatDateTime(formatDate(selectedDate), selectedTimeSlot) : "";

  const handleSearch = async () => {
    updateURLParams();
    const location = await triggerLocation(handleOpenModal);
    await dispatch(getVenueListforReservation(location, tableSize, formattedTime));
  };


  const generateTimeSlots = (date) => {
    const slots = [];
    const now = new Date();
    const selectedDay = new Date(date).setHours(0, 0, 0, 0);
    const today = new Date().setHours(0, 0, 0, 0);

    let start = selectedDay === today
      ? Math.ceil((now.getHours() * 60 + now.getMinutes()) / 30) * 30
      : 0;

    let end = 24 * 60;

    while (start < end) {
      let hours = Math.floor(start / 60);
      let minutes = start % 60;
      let period = hours >= 12 ? "pm" : "am";
      let formattedHours = hours > 12 ? hours - 12 : hours === 0 ? 12 : hours;
      let paddedHours = formattedHours < 10 ? `0${formattedHours}` : `${formattedHours}`;
      let formattedMinutes = minutes === 0 ? "00" : minutes;
      slots.push(`${paddedHours}:${formattedMinutes} ${period}`);
      start += 30;
    }
    setTimeSlots(slots);
  };
  const handleDateChange = (date) => {
    setSelectedDate(date);
  };



  return (
    <Box
      sx={{
        marginLeft: "35px",
        marginRight: "35px",
        "@media (max-width: 1025px)": {
          marginLeft: "0px",
          marginRight: "0px",
        },
      }}
    >
      <Container maxWidth="xl">
        <Box
          sx={{
            marginTop: "200px",
            "@media (max-width: 600px)": {
              marginTop: "185px",
            },
          }}
        >
          {isReservation == 'true' ?
            <>
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "nowrap",
                  alignItems: "center",
                  gap: {
                    xs: 0.5,
                    sm: 0.5,
                    md: 1,
                    lg: 1,
                    xl: 1,
                  },
                  justifyContent: "center",
                  mb: "8px",
                }}
              >
                <TextField
                  select
                  value={tableSize}
                  onChange={(e) => handleInputChange(e, "partySize")}
                  sx={{
                    width: "100%",
                    minWidth: "115px",
                    fontSize: "11px",

                    "& .MuiOutlinedInput-root": {
                      borderRadius: "12px",
                      height: 44,
                    },
                    "&:hover fieldset": {
                      borderColor: "#FCA92E !important",
                    },
                    "& fieldset": {
                      borderColor: "#ccc",
                    },
                    "& .MuiSelect-select": {
                      fontSize: {
                        xs: "11px",
                        sm: "13px",
                        md: "14px",
                      },
                      paddingTop: "12px",
                      paddingBottom: "12px"
                    },
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <img
                          src="/assets/icons/reservation/partySize.svg"
                          alt="Guests"
                          width={18}
                          style={{ marginRight: 4 }}
                        />
                      </InputAdornment>
                    ),
                  }}
                >
                  {tableSizesList?.tableSizes?.map((number) => (
                    <MenuItem key={number} value={number}>
                      {number} Guests
                    </MenuItem>
                  ))}
                </TextField>

                <DatePicker
                  value={selectedDate || new Date()}
                  onChange={(newDate) => {
                    handleInputChangeDate(newDate, "selectedDate");
                    setOpen(false);
                  }}
                  open={open}
                  onClose={() => setOpen(false)}
                  onOpen={() => setOpen(true)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      sx={{
                        width: "100%",
                        minWidth: "110px",
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "12px",
                          height: 44,
                        },
                        "& fieldset": {
                          borderColor: "#ccc",
                        },
                        "&:hover fieldset": {
                          borderColor: "#FCA92E !important",
                        },
                        "& input": {
                          fontSize: {
                            xs: "11px",
                            sm: "13px",
                            md: "14px",
                          },
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        },
                      }}
                      inputProps={{ ...params.inputProps, readOnly: true }}
                      InputProps={{
                        ...params.InputProps,
                        startAdornment: (
                          <InputAdornment position="start">
                            <img
                              src="/assets/icons/reservation/calendar.svg"
                              alt="Calendar"
                              width={18}
                              style={{ marginRight: 4 }}
                            />
                          </InputAdornment>
                        ),
                        endAdornment: null,
                      }}
                      onClick={() => setOpen(true)}
                    />
                  )}
                  minDate={new Date()}
                />

                <TextField
                  select
                  value={selectTime}
                  onChange={(e) => handleInputChange(e, "time")}
                  sx={{
                    width: "100%",
                    minWidth: "110px",
                    fontSize: "11px",
                    "&:hover fieldset": {
                      borderColor: "#FCA92E !important",
                    },
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "12px",
                      height: 44,
                    },
                    "& fieldset": {
                      borderColor: "#ccc",
                    },
                    "& .MuiSelect-select": {
                      fontSize: {
                        xs: "11px",
                        sm: "13px",
                        md: "14px",
                      },
                      paddingTop: "12px",
                      paddingBottom: "12px"
                    },
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <img
                          src="/assets/icons/reservation/clock.svg"
                          alt="Time"
                          width={18}
                          style={{ marginRight: 4 }}
                        />
                      </InputAdornment>
                    ),
                  }}
                >
                  {timeSlots.map((time, index) => (
                    <MenuItem key={index} value={time}>
                      {time}
                    </MenuItem>
                  ))}
                </TextField>
              </Box>

            </> : ""}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "20px",
              flexWrap: "nowrap",
              gap: 1,
              width: "100%",
              "@media (max-width: 600px)": {
                flexWrap: "nowrap",
              },
            }}
          >
            <TextField
              fullWidth
              placeholder="Search your favourite venue"
              variant="outlined"
              margin="dense"
              value={searchQuery}
              onChange={handleSearchChange}
              sx={{
                backgroundColor: "white",
                borderRadius: "10px",
                "& fieldset": {
                  borderColor: "#FCA92E",
                },
                "&:hover fieldset": {
                  borderColor: "#FCA92E !important",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#FCA92E !important",
                },
                "& .MuiInputBase-input": {
                  padding: "14px 14px 14px 0px",
                  fontSize: {
                    xs: "11px",
                    sm: "13px",
                    md: "14px",
                  },
                },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Iconify
                      sx={{
                        height: 20,
                        width: 20,
                        cursor: "pointer",
                      }}
                      icon={"material-symbols:search"}
                    />
                  </InputAdornment>
                ),
              }}
            />

            {isReservation == 'true' ?
              <>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Button
                    variant="contained"
                    sx={{
                      backgroundColor: "#F59B34",
                      // color: "white",
                      borderRadius: "10px",
                      height: "45px",
                      fontSize: {
                        xs: "13px",
                        sm: "13px",
                        md: "16px",
                        lg: "16px",
                        xl: "16px",
                      },
                      fontWeight: "700",
                      textTransform: "none",
                      minWidth: "150px",
                      display: "flex",

                      alignItems: "center",
                      "&:hover": {
                        backgroundColor: "#e08a1e",
                      },
                      "@media (max-width: 600px)": {
                        minWidth: "110px",
                        padding: "0 10px",
                      },
                    }}
                    onClick={handleSearch}
                  >
                    Let's go
                  </Button>
                </Box>
              </>
              : ""}

          </Box>

        </Box>
        <NewVenue
          searchQuery={searchQuery}
          selectedTableSize={tableSize}
          tempTableSize={tempTableSize}
          selectedDate={selectedDate}
          selectedTime={selectTime}
        />
        <AllVenues
          searchQuery={searchQuery}
          selectedTableSize={tableSize}
          tempTableSize={tempTableSize}
          selectedDate={selectedDate}
          selectedTime={selectTime}
        />
      </Container>
    </Box>
  );
};

export default VenueCuisines;
